import { render } from "./TextSection.vue?vue&type=template&id=057c1d28&ts=true"
import script from "./TextSection.vue?vue&type=script&lang=ts"
export * from "./TextSection.vue?vue&type=script&lang=ts"

import "./TextSection.vue?vue&type=style&index=0&id=057c1d28&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__